@if(finalAssets.length === 0){
<p>No completed streams found.</p>
}@else {

<div class="col gap-12 w100 streamlistwrapper">
    @for(stream of finalAssets; track stream.streamId; let i = $index){
    <div
        class="stream space-between row align-center"
        [ngClass]="stream.active === true ? 'selected' : ''"
        (click)="setAssetActive(i)"
    >
        <div class="row gap-16 align-center">
            <div class="dot"></div>
            <div class="col">
                <div class="strong">{{ stream.name }}</div>
                <div class="tiny">
                    <rr-badge>
                        {{ findStreamNameByConfigId(stream.configId) }}
                    </rr-badge>
                </div>
            </div>
        </div>
        <div class="col gap-8 align-end w40">
            <!-- <rr-icon name="external_link" color="nutral" class="w24"></rr-icon> -->
            <div class="tiny">
                {{ stream.dateFinished | localTimeDate }}
            </div>
        </div>
    </div>
    }
</div>
}

<div class="btnrow row w100 gap-16 justify-end align-center">
    <div class="row gap-8">
        <rr-btn size="Small" type="Secondary" (click)="close.emit('close')"
            >Cancel</rr-btn
        >
        @if(finalAssets.length !== 0){
        <rr-btn
            size="Small"
            type="Primary"
            [disabled]="selectedData === null"
            (click)="
                selectedData === null ? null : usecontent.emit(selectedData)
            "
            >Use content
        </rr-btn>
        }
    </div>
</div>

